/* istanbul ignore file */
import { Box } from '@elparking/components'
import styled from 'styled-components'

export const IconContainer = styled(Box)`
    height: fit-content;
    padding: 0.5em;
    border-radius: 50%;
`
